import React, { memo } from 'react';
import { Collapse } from '../../../../collapse';
import { ListItem } from '../../../../list-item';
import styled from 'styled-components';
const StyledLastItem = styled(ListItem) `
  > div {
    padding: 0;
  }
`;
export const SavedItemsContainer = memo(function SavedItemsContainer({ children, useCollapse, isOpen }) {
    return useCollapse ? (React.createElement(Collapse, { isOpen: isOpen, component: "li" },
        children,
        React.createElement(StyledLastItem, null))) : (React.createElement(React.Fragment, null, children));
});
